import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import Transaction from '../modules/TransactionUser/main';

export const Route = createFileRoute('/transactions')({
  component: Transaction,
  // Phones and tablets open a receipt, and its affidavit, as pages: in the URL, so a refresh keeps
  // them and the phone's Back steps out. Desktop doesn't read these.
  validateSearch: z.object({
    receipt: z.coerce.number().int().positive().optional(),
    affidavit: z.enum(['missing', 'recurring']).optional(),
  }),
  head() {
    return {
      meta: [{ title: 'User Transactions' }],
    };
  },
});
